import React, {useMemo, useRef} from "react";
import { Autocomplete, AutocompleteProps } from '@mui/material';
import {TextField, TextFieldProps} from "@mui/material";
import {compareByField, distinctByField} from "~/apps/core/utils";
import {useContractList} from "~/apps/packages/auto-shipment-orders/hooks";
import {Contract} from "~/apps/packages/auto-shipment-orders/queries";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";

export type ContractSelectProps = {
    value?: Contract,
    onChange?: (value: Contract) => any
    additionalOptions?: Contract[]
} & Omit<TextFieldProps, "value" | "onChange">;

const useStyles = makeStyles<PortTheme>((theme) => ({
    option: {
        fontSize: "12px!important",
        lineHeight: "20px!important",
        height: 'auto!important',
        padding: '12px 10px!important',
        position: 'relative',
        '&:not(:first-child):before': {
            content: '""',
            width: 'calc(100% - 20px)',
            position: 'absolute',
            top: 0,
            left: 10,
            borderTop: '1px solid rgba(110, 121, 140, 0.07)'
        }
    },
}))

export const ContractSelect = (props: ContractSelectProps) => {
    const {onChange, value, additionalOptions, ...otherProps} = props;
    const {data} = useContractList();
    const inputRef = useRef<HTMLInputElement>();
    const loading = !data;
    const styles = useStyles();
    const handleChange = (e:  React.SyntheticEvent, value: Contract) => {
       // const value = availableValues.find(item => item.id == e.target.value);

        onChange && onChange(value);
    }

    const availableValues = useMemo(() => {
        const availableValues: Contract[] = [].concat(data).filter(Boolean);
        return distinctByField(availableValues, "id").sort(compareByField("number"));
    }, [data]);

    return (
        <Autocomplete
            {...otherProps as any as AutocompleteProps<Contract, any, any, any>}
            value={value}
            onChange={handleChange}
            renderInput={props => (
                <TextField {...props} inputRef={inputRef} label="Договор" placeholder="Выбрать"/>
            )}
            getOptionLabel={(option: Contract) => option.number}
            isOptionEqualToValue={(option: Contract, value: Contract) => value.number == option.number}
            options={availableValues}
            loading={loading}
            noOptionsText="Не найдено"
            loadingText="Загрузка..."
            blurOnSelect
            classes={{option: styles.option}}
        />
    );
}
